import { memo, useCallback, useEffect, useState } from 'react';
import { BzButton, BzHeading, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Container, Row, Col, } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { toastConfig } from '../../redux/actions/toast';
import { handleModal } from '../../redux/actions/modals';
import { addNewWatchlist, getColumnDef, updateSelectedWatchlist } from '../../redux/actions/watchlist';
import RenameModal from './RenameModal';
import { deepClone, getAppInfoData, getDecryptLocalStorage, returnCountWithPad, getscripCountPerWatchlist, isGuestUser } from '../../utils/global_functions';
import { WATCHLIST_GRID_INDEX, DEEP_LINK, MY_HOLDINGS_WATCHLIST_NAME, DONT_MISS_WATCHLIST_NAME, APP_INFO_PARAMS, LOCATIONS, APP_INFO_DEFAULT_VALUES } from '../../utils/global_variables';
import { _addingGlobalWatchlist, _checkForSpecialChars, _filterWatchlistForSystemDefined, _renamingGlobalWatchlist } from '../../controllers';
import { useLocation } from 'react-router';




const GlobalWatchlistScripsModal = (props) => {

    const location = useLocation();
    const { setBIsEmptyWatchlistView } = props;
    const { isWatchlistPresent, selectedWatchlist, watchlists, globalWatchlists } = useSelector(state => state?.watchList);
    const modals = useSelector(state => state?.modals?.modals);
    const { appInfo } = useSelector(state => state.appInfo);
    const dispatch = useDispatch();
    const [scrips, setScrips] = useState([]); //state used to store scrips of selectedWatchlist then used in while create new watchlist
    const [checkedScrips, setCheckedScrips] = useState([]);


    //Ameersha N : Breeze BT-95888 Create Watchlist feature --Start
    const handleInputOnchange = useCallback((e) => {
        //This Function is used to know the scrips that are unchecked and checked
        const checkedScripsCopy = checkedScrips;

        if (e.target.checked) {
            checkedScripsCopy.push(JSON.parse(e?.target.value));
            setCheckedScrips([...checkedScripsCopy]);
        } else {
            let nIndex = checkedScripsCopy?.findIndex((eachScrip) => eachScrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN] === e.target.id);
            checkedScripsCopy.splice(nIndex, 1);
            setCheckedScrips([...checkedScripsCopy]);

        }
    }, [checkedScrips]);
    // Ameersha N | BT-95888 Create Watchlist Feature End

    useEffect(() => {
        const selectedWatchlistScrips = deepClone(selectedWatchlist?.scrips);
        setCheckedScrips(selectedWatchlistScrips);
    }, [selectedWatchlist, setCheckedScrips]);
    //Ameersha N : Breeze BT-95888 Create Watchlist feature --End
    // Ameersha N | BT-95888 Create Watchlist Feature start
    const onAddGlobalWatchlist = useCallback((selectedWatchlist, selectedScrips) => {
        // Hari k:22-03-2024: BT-108447: create watchlist from list- start
        if (selectedWatchlist?.sWtachlistType === "static") {
            const maxWatchlist = getAppInfoData(APP_INFO_PARAMS.APP_MAX_PROFILE_COUNT,APP_INFO_DEFAULT_VALUES.APP_MAX_PROFILE_COUNT); //Ameersha N - BT-109369 - 01-03-2024 - Share Watchlist - Issue able to add more than exceed limit fixed
            if (watchlists?.length >= maxWatchlist) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Exceeded  watchlists limit ${maxWatchlist} !` }));
            }
            else if (selectedScrips?.length > getscripCountPerWatchlist()) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cannot add more than ${getscripCountPerWatchlist()} scrips`, }));
            }
            else {
                // let existingWatlist = watchlists?.length ? watchlists?.find((each) => each?.sWatchListName?.toLowerCase() === selectedWatchlist?.sWatchListName?.toLowerCase()) : false;
                // if (existingWatlist && Object.keys(existingWatlist)?.length > 0) {
                //     dispatch(toastConfig({ autoDismiss: true, show: true, message: ` ${selectedWatchlist?.sWatchListName} watchlist name already exists!` }));
                // } else { }
                dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": false }]));
                dispatch(handleModal([{ "WATCHLIST_NAMING_MODAL": true }]));
            }
            // Hari k:22-03-2024: BT-108447: create watchlist from list-end
        } else {
            if (watchlists && watchlists.length > 0) {
                let globalWatchlistHandler = _addingGlobalWatchlist(watchlists, selectedWatchlist, isWatchlistPresent, selectedScrips);

                if (!globalWatchlistHandler?.status) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: globalWatchlistHandler?.message }));
                }
                else {
                    if (getDecryptLocalStorage(DEEP_LINK) !== null) {
                        const maxWatchlist = getAppInfoData(APP_INFO_PARAMS.APP_MAX_PROFILE_COUNT,APP_INFO_DEFAULT_VALUES.APP_MAX_PROFILE_COUNT); //Ameersha N - BT-109369 - 01-03-2024 - Share Watchlist - Issue able to add more than exceed limit fixed
                        if (watchlists?.length >= maxWatchlist) {
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Exceeded  watchlists limit ${maxWatchlist} !` }));
                        } else {
                            let wathlistToSearch = getDecryptLocalStorage(DEEP_LINK) !== null ? JSON.parse(getDecryptLocalStorage(DEEP_LINK)).username : selectedWatchlist?.sWatchListName;
                            let objExistingWatchlist = globalWatchlists?.length ? globalWatchlists?.find((each) => each?.sWatchListName?.toLowerCase() === wathlistToSearch?.toLowerCase()) : false;



                            let existingWatlist = watchlists?.length ? watchlists?.find((each) => each?.sWatchListName?.toLowerCase() === wathlistToSearch?.toLowerCase()) : false;

                            if (objExistingWatchlist || wathlistToSearch?.toLowerCase()?.length <= 0 || existingWatlist || wathlistToSearch?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME || wathlistToSearch?.toLowerCase() === DONT_MISS_WATCHLIST_NAME) {
                                dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": false }]));
                                dispatch(handleModal([{ "WATCHLIST_NAMING_MODAL": true }]));
                                dispatch(toastConfig({ show: true, message: 'Watchlist name already exists. Please choose a different name' }));
                            } else {
                                let copy = globalWatchlistHandler?.data?.objSelectedWatchlist;
                                copy.sWatchListName = wathlistToSearch;
                                dispatch(addNewWatchlist(copy))?.then(() => {
                                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `${wathlistToSearch} (${globalWatchlistHandler?.data?.objSelectedWatchlist?.scrips?.length}) successfully added to your watchlist` }));
                                    if(isGuestUser()){
                                        dispatch(getColumnDef())
                                    }
                                });
                                dispatch(updateSelectedWatchlist([]));
                                localStorage.removeItem(DEEP_LINK);
                                if (isWatchlistPresent && _filterWatchlistForSystemDefined(watchlists)?.data?.filteredWatchlist.length === 0) {
                                    setBIsEmptyWatchlistView(false);
                                }
                                setScrips([]);
                            }
                        }

                    } else {
                        dispatch(addNewWatchlist(globalWatchlistHandler?.data?.objSelectedWatchlist))?.then(() => {
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `${globalWatchlistHandler?.data?.objSelectedWatchlist?.sWatchListName} (${globalWatchlistHandler?.data?.objSelectedWatchlist?.scrips?.length}) successfully added to your watchlist` }));
                            if(isGuestUser()){
                                dispatch(getColumnDef())
                            }
                        });
                        dispatch(updateSelectedWatchlist([]));
                        if (isWatchlistPresent && _filterWatchlistForSystemDefined(watchlists)?.data?.filteredWatchlist.length === 0) {
                            setBIsEmptyWatchlistView(false);
                        }
                        setScrips([]);
                    }
                }
            } else { }
            dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": false }]));
        }

    }, [dispatch, watchlists, appInfo, setBIsEmptyWatchlistView, globalWatchlists, isWatchlistPresent]);
    // Ameersha N | BT-95888 Create Watchlist Feature End

    // Hari k | BT-95888 Create Watchlist Feature start
    const [isAllScripsSelected, setIsAllScripsSelected] = useState(true);
    const handleAllScripschange = (isSelected) => {
        if (isSelected) {
            const selectedWatchlistScrips = deepClone(selectedWatchlist?.scrips);
            setCheckedScrips(selectedWatchlistScrips);
        } else {
            setCheckedScrips([]);
        }
        setIsAllScripsSelected(!isAllScripsSelected);
    };
    // Hari k | BT-95888 Create Watchlist Feature end


    // Ameersha N | BT-95888 Create Watchlist Feature start
    const onSubmit = (e) => {
        e.preventDefault();
        let arrSelectedScrips = [];
        // Hari k:30-04-2024: BT-108447: create watchlist from list-start
        if (selectedWatchlist?.sWtachlistType === "static") {
            setScrips([...checkedScrips]);
            onAddGlobalWatchlist(selectedWatchlist, checkedScrips);
            // Hari k:30-04-2024: BT-108447: create watchlist from list-end
        } else {
            if (e.target.scrip_checkbox?.length > 0) {
                e.target.scrip_checkbox.forEach(elem => {
                    if (elem.checked) {
                        arrSelectedScrips.push(JSON.parse(elem?.value));
                        setScrips(prevItems => [...prevItems, JSON.parse(elem?.value)]);
                    } else if (getDecryptLocalStorage(DEEP_LINK) !== null) {
                        onAddGlobalWatchlist(selectedWatchlist, checkedScrips);
                    }
                    else {
                        dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": false }]));
                        dispatch(handleModal([{ "WATCHLIST_NAMING_MODAL": true }]));
                    }
                });

            } else if (e.target.scrip_checkbox) {
                if (e.target.scrip_checkbox.checked) {
                    arrSelectedScrips = [JSON.parse(e.target.scrip_checkbox?.value)];
                }
                else {
                    dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": false }]));
                    dispatch(handleModal([{ "WATCHLIST_NAMING_MODAL": true }]));
                }
            } else { }
            if (selectedWatchlist?.scrips?.length === arrSelectedScrips?.length) {
                onAddGlobalWatchlist(selectedWatchlist, arrSelectedScrips);
            } else { }
        }
        setIsAllScripsSelected(true);
        // localStorage.removeItem(DEEP_LINK);
    };
    // Ameersha N | BT-95888 Create Watchlist Feature end

    // Ameersha N | BT-95888 Create Watchlist Feature start
    const onHide = () => {
        localStorage.removeItem(DEEP_LINK);
        dispatch(handleModal([{ "GLOBAL_WATCHLIST_SCRIPT_MODAL": false }]));
    };
    // Ameersha N | BT-95888 Create Watchlist Feature End

    // Ameersha N | BT-95888 Create Watchlist Feature start
    const onBack = () => {
        localStorage?.removeItem(DEEP_LINK);
        dispatch(updateSelectedWatchlist([]));
        if (selectedWatchlist?.sWtachlistType === undefined && selectedWatchlist?.sWtachlistType?.toLowerCase() !== "static") {
            dispatch(handleModal([{ 'GLOBAL_WATCHLIST_SCRIPT_MODAL': false }, { 'CREATE_WATCHLIST_MODAL': true }]));
        } else {
            dispatch(handleModal([{ 'GLOBAL_WATCHLIST_SCRIPT_MODAL': false }]));

        }
    };
    // Ameersha N | BT-95888 Create Watchlist Feature End


    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const [renamedWatchlistName, setRenamedWatchlistName] = useState('');


    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const handleChange = (event) => {
        const { value } = event.target;
        if (!_checkForSpecialChars(value)?.status) {
            setRenamedWatchlistName(value);
        } else if (event?.nativeEvent?.inputType === 'deleteContentBackward') {
            setRenamedWatchlistName(value);
        } else { }
    };
    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - End


    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const cancelReanmingModal = useCallback(() => {
        localStorage.removeItem(DEEP_LINK);
        dispatch(handleModal([{ 'WATCHLIST_NAMING_MODAL': false }]));
    }, [dispatch]);
    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - End


    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - Start
    const onRenameWatchlist = useCallback(() => {


        if (getDecryptLocalStorage(DEEP_LINK) !== null) {
            if (watchlists && watchlists.length > 0) {
                const watchlistName = JSON.parse(getDecryptLocalStorage(DEEP_LINK)).username;
                const copy = selectedWatchlist;
                copy.sWatchListName = watchlistName;
                let globalWatchlistHandler = _renamingGlobalWatchlist(watchlists, copy, isWatchlistPresent, scrips, renamedWatchlistName);
                if (globalWatchlistHandler?.status) {
                    dispatch(handleModal([{ "WATCHLIST_NAMING_MODAL": false }]));
                    dispatch(addNewWatchlist(globalWatchlistHandler?.data?.objSelectedWatchlist))?.then((objResp) => {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `${globalWatchlistHandler?.data?.objSelectedWatchlist?.sWatchListName} (${returnCountWithPad(selectedWatchlist?.scrips?.length)}) successfully added to your  watchlist` }));
                        dispatch(updateSelectedWatchlist([]));
                        if(isGuestUser()){
                            dispatch(getColumnDef())
                        }
                    });
                    setScrips([]);
                    dispatch(toastConfig({}));
                    localStorage.removeItem(DEEP_LINK);
                }
                else {
                    dispatch(toastConfig({ show: true, message: globalWatchlistHandler?.message, button: [{ btnName: "OK", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));
                }
            } else { }

        } else {
            if (watchlists && watchlists.length > 0) {
                let globalWatchlistHandler = _renamingGlobalWatchlist(watchlists, selectedWatchlist, isWatchlistPresent, scrips, renamedWatchlistName);
                if (globalWatchlistHandler?.status) {
                    dispatch(handleModal([{ "WATCHLIST_NAMING_MODAL": false }]));
                    dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
                    dispatch(addNewWatchlist(globalWatchlistHandler?.data?.objSelectedWatchlist))?.then((objResp) => {
                        if (location?.pathname === LOCATIONS.WATCHLISTP) {
                            dispatch(toastConfig({ show: true, message: `${selectedWatchlist?.sWatchListName} (${returnCountWithPad(selectedWatchlist?.scrips?.length)}) successfully added to your  watchlist` }));
                        } else {
                            dispatch(toastConfig({ button: [{ btnName: "view", type: "VIEW_WATCHLIST", className: "btn btn-outline-active ms-3" }], show: true, message: `${selectedWatchlist?.sWatchListName} (${returnCountWithPad(selectedWatchlist?.scrips?.length)}) successfully added to your  watchlist` }));
                        }
                        dispatch(updateSelectedWatchlist([]));
                        if(isGuestUser()){
                            dispatch(getColumnDef())
                        }
                    });
                    setScrips([]);
                    dispatch(toastConfig({}));
                }
                else {
                    dispatch(toastConfig({ show: true, message: globalWatchlistHandler?.message, button: [{ btnName: "OK", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));
                }
            } else { }
        }




    }, [selectedWatchlist, watchlists, isWatchlistPresent, dispatch, scrips, renamedWatchlistName]);
    //Ameersha N : 03-05-2023 : BT-95888 - Breeze - Create Watchlist Reanaming Feature - End






    /*BT-109369 Breeze- Watchlist- Share Watchlist if user is directly coming from a shared url then button should be disabled--start*/
    const button = getDecryptLocalStorage(DEEP_LINK) !== null ? false : true;
    const watchlistName = getDecryptLocalStorage(DEEP_LINK) !== null ? JSON.parse(getDecryptLocalStorage(DEEP_LINK)).username : null;
    /*BT-109369 Breeze- Watchlist- Share Watchlist --end*/


    // Ameersha N | BT-95888 Create Watchlist Feature start
    useEffect(() => {
        if (getDecryptLocalStorage(DEEP_LINK)) {
            const watchlistName = JSON.parse(getDecryptLocalStorage(DEEP_LINK)).username;
            setRenamedWatchlistName(watchlistName);
        } else {
            setRenamedWatchlistName(selectedWatchlist?.sWatchListName);
        }

    }, [selectedWatchlist]);
    // Ameersha N | BT-95888 Create Watchlist Feature End


    return (
        <>
            <RenameModal show={modals['WATCHLIST_NAMING_MODAL']} renamedWatchlistName={renamedWatchlistName} handleChange={handleChange} cancelModal={cancelReanmingModal} onRenameWatchlist={onRenameWatchlist} activeWatchList={{}} />
            <BzModal show={modals['GLOBAL_WATCHLIST_SCRIPT_MODAL']} onHide={onHide} className='p-3'>
                <BzModalHeader className='bdr-none'>
                    <Container fluid className='p-0 pb-4 bdr-btm'>
                        <Row className='g-0 justify-content-between align-items-center'>
                            <Col md={9} className='d-flex justify-content-start'>
                                <BzHeading className='font-medium font-size4 color-text'>Review &amp; {selectedWatchlist?.sWtachlistType === "static" ? ` add the ${selectedWatchlist?.sListName} to your Watchlist` : "Add this watchlist"} </BzHeading>
                            </Col>
                            {button ? <Col md={3} className='d-flex justify-content-end'>
                                <BzButton data-testid="watchlist-reviewwatchlist-modal-goback-button" className='btn btn-md btn-outline btn-rounded' onClick={onBack}>Go Back</BzButton>
                            </Col> : <Col md={3} className='d-flex justify-content-end'>
                                <BzButton  data-testid="watchlist-reviewwatchlist-modal-cancel-button" className='btn btn-md btn-outline btn-rounded' onClick={onHide}>Cancel</BzButton>
                            </Col>}
                        </Row>
                        <Row className='g-0 mt-3'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size2 color-text'>{watchlistName ? watchlistName : selectedWatchlist?.sWatchListName}</div>
                                <div className='font-regular font-size2 color-subtext ms-2'>({selectedWatchlist?.scrips?.length} Scrips)</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <form onSubmit={onSubmit}>
                    <BzModalBody>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col>
                                    <div className='d-flex align-items-center mb-4'>
                                        <input type="checkbox" onChange={() => handleAllScripschange(!isAllScripsSelected)}
                                            checked={isAllScripsSelected} className='form-check-input me-2' />
                                        <label className='d-flex  align-items-center'>
                                            <div className='font-medium font-size4 color-subtext'> {isAllScripsSelected ? "Unselect All" : "Select All"}</div>
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0 mb-2'>
                                <Col md={12}>
                                    <div className='watchlist-addreview-container'>
                                        {selectedWatchlist?.scrips?.map((each) => (
                                            <div className='d-flex align-items-center mb-4' key={`${each[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}`}>
                                                <input type="checkbox" onChange={(e) => handleInputOnchange(e)} id={`${each[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}`} name='scrip_checkbox' value={JSON.stringify(each)}
                                                    checked={checkedScrips?.some(element => element[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN] === each[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]) ? true : false} className='form-check-input me-2' />
                                                <label className='d-flex  align-items-center' htmlFor={`${each[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}`}>
                                                    <div className='font-medium font-size4 color-text'>{each[WATCHLIST_GRID_INDEX?.SYMBOL]}</div>
                                                    <div className='chips-wrap px-2'>
                                                        <div className='exchange-chip text-capitalize'>
                                                            {each[WATCHLIST_GRID_INDEX?.EXCHANGE]}
                                                        </div>
                                                    </div>
                                                    <div className='font-regular font-size4 color-subtext'>{each[WATCHLIST_GRID_INDEX?.SERIES]}</div>
                                                    <div className='font-regular font-size4 color-subtext me-2'>{each[WATCHLIST_GRID_INDEX?.EXPIRYDATE]}</div>
                                                    <div className='font-regular font-size4 color-subtext me-2'>{each[WATCHLIST_GRID_INDEX?.STRIKEPRICE]}</div>
                                                    <div className='font-regular font-size4 color-subtext'>{each[WATCHLIST_GRID_INDEX?.OPTIONTYPE]}</div>
                                                </label>
                                            </div>

                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalBody>
                    <BzModalFooter>
                        <Container fluid className='p-0 m-0'>
                            <Row className='g-0 align-items-center'>
                                <Col md={9} className='d-flex justify-content-start align-items-center'>
                                    <div className='font-regular font-size2 color-subtext d-inline'>Add New Watchlist </div>
                                    <div className='font-medium font-size2 color-text d-inline ms-1 pt-1s'>{watchlistName ? watchlistName : selectedWatchlist?.sWatchListName}</div>
                                    <div className='number-badge-watchlist ms-2'>{checkedScrips?.length}</div>
                                </Col>
                                <Col md={3} className='d-flex justify-content-end'>
                                    <BzButton  data-testid="watchlist-reviewwatchlist-modal-done-button" disabled={checkedScrips?.length <= 0 ? true : false} type='submit' className='btn btn-md btn-primary'>Done</BzButton>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalFooter>
                </form>
            </BzModal>
        </>
    );
};

export default memo(GlobalWatchlistScripsModal);